import { inject } from "@angular/core";
import { CanActivateFn } from "@angular/router";
import { LoginService } from "../services/login.service";
import { first } from "rxjs/operators";
import { WebSocketConnectionStatus } from "../modules/conversation/models/message.model";
import {WebSocketSharedService} from "../modules/conversation/services/websocket-shared.service";

/**
 * A non-blocking functional route guard that ensures a WebSocket connection
 * attempt is made if the user is logged in but the socket is disconnected.
 */
export const ensureSocketConnectedGuard: CanActivateFn = () => {
    const loginService = inject(LoginService);
    const sharedWebSocketAPI = inject(WebSocketSharedService);
    // First, check if the user is authenticated. We don't want to connect for guests.
    if (loginService.isLoggedIn()) {
        // `pipe(first())` to get the *current* status once
        sharedWebSocketAPI
            .getConnectionState$()
            .pipe(first())
            .subscribe((currentState) => {
                // If the connection is closed or has errored out, command a reconnect.
                if (
                    currentState === WebSocketConnectionStatus.CLOSED ||
                    currentState === WebSocketConnectionStatus.ERROR
                ) {
                    console.log("Guard (Functional): Forcing a WebSocket connection attempt.");
                    // webSocketAPI.connect();
                    sharedWebSocketAPI.connect().then();
                }
            });
    }
    // returning true to navigate to the route instantly while the connection happens in the background.
    return true;
};
